import { api } from './Api-Endpoints/apiEndpoint';
import { loadFolders } from './Redux/FolderSlice';
import { LoadOrganization } from './Redux/OrganizationSlice';
import { LoadProcedures } from './Redux/ProcedureReducer';
import { _loadRole } from './Redux/RoleSlice';
import { loadUsers } from './Redux/UserSlice';
import store from './store';

class ApiHandler {
  getRoles(id) {
    // console.log(id);
    api
      .get(`/role/getRoles/${id}`)
      .then(res => {
        if (res.status == 200) {
          store.dispatch(_loadRole(res.data.roles));
        }
      })
      .catch(error => console.log(error));
  }
  getOrgList() {
    api.get('/org/org-list').then(res => {
      if (res.status === 200) {
        store.dispatch(LoadOrganization(res.data.organizations));
      }
    });
  }
  getProcedureList() {
    api
      .get('/procedure/list-procedure')
      .then(res => {
        if (res.status === 200) {
          store.dispatch(LoadProcedures(res.data.procedures));
        }
      })
      .catch(error => console.log(error));
  }
  async getUsers(_id) {
    try {
      const { status, data } = await api.get(`/user/user-list/${_id}`);
      if (status == 200) {
        store.dispatch(loadUsers(data.users));
        return data;
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  async getUserById(_id) {
    try {
      const res = await api.get(`/user/getUserById/${_id}`);
      console.log(res, 'xxxx');
      // if (status == 200) {
      //   return data.user;
      // }
    } catch (error) {
      console.log(error.message);
    }
  }
  async getFolders() {
    try {
      const { status, data } = await api.get('/folder/getfolders');
      if (status == 200) {
        store.dispatch(loadFolders(data.folders));
      }
    } catch (error) {
      console.log(error.message);
    }
  }
  getOrgByUser(id) {
    api
      .get(`/org/org-list/${id}`)
      .then(res => {
        if (res.status === 200) {
          store.dispatch(LoadOrganization(res.data.organizations));
        }
      })
      .catch(error => console.log(error));
  }
  getProcedureByUser(id) {
    api
      .get(`/procedure/proceduregetbyuser/${id}`)
      .then(res => {
        if (res.status === 200) {
          store.dispatch(LoadProcedures(res.data.procedures));
        }
      })
      .catch(error => console.log(error));
  }
}
export default new ApiHandler();
